export const tipoServicioOptions = [
  "Mudanza",
  "Acarreo",
  "Evento",
  "Distribución",
  "Reparto",
  "Transporte empresarial",
  "Transporte de personas",
  "Otro",
];

export const unidadTipoOptions = [
  "Camión",
  "Furgoneta",
  "Autobús",
  "Camión de mudanza",
  "Camión de carga",
  "Otra unidad",
];

export const tipoCargaOptions = [
  "Muebles y enseres",
  "Equipos y maquinaria",
  "Materiales de construcción",
  "Mercadería y paquetes",
  "Producción de eventos",
  "Documentos y archivo",
  "Carga especial",
  "No aplica",
];